import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_900, Button, checkIsPlatform, Typography, typographyConfig } from '@airtel/air-design-system';
import { useRef, useState } from 'react';
import { View } from 'react-native';
var TruncatedText = _ref => {
  var _ref$buttonProps = _ref.buttonProps,
    buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$numberOfLines = _ref.numberOfLines,
    numberOfLines = _ref$numberOfLines === void 0 ? 3 : _ref$numberOfLines,
    _ref$readMoreText = _ref.readMoreText,
    readMoreText = _ref$readMoreText === void 0 ? 'read more' : _ref$readMoreText,
    type = _ref.type,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    _ref$textAlignment = _ref.textAlignment,
    textAlignment = _ref$textAlignment === void 0 ? 'left' : _ref$textAlignment,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? BLACK_900 : _ref$color;
  var _useState = useState(true),
    isMeasuring = _useState[0],
    setIsMeasuring = _useState[1];
  var _useState2 = useState(false),
    isTruncated = _useState2[0],
    setIsTruncated = _useState2[1];
  var _useState3 = useState(false),
    isExpanded = _useState3[0],
    setIsExpanded = _useState3[1];
  var textRef = useRef(null);
  var styles = checkIsPlatform('web') && {
    display: '-webkit-box'
  };
  var justifyContentProperty = textAlignment === 'left' ? 'flex-start' : textAlignment === 'right' ? 'flex-end' : textAlignment === 'center' ? 'center' : 'center';
  var toggleTextShown = () => {
    setIsExpanded(true);
  };
  var onLayout = event => {
    if (isMeasuring) {
      var height = event.nativeEvent.layout.height;
      var lineHeight = typographyConfig[theme].config.types[type].typographyStyles.lineHeight;
      var maxHeight = lineHeight * numberOfLines;
      if (height > maxHeight) {
        setIsTruncated(true);
      }
      setIsMeasuring(false);
    }
  };
  return _jsx(_Fragment, {
    children: _jsxs(View, Object.assign({
      style: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: justifyContentProperty
      }
    }, {
      children: [_jsx(Typography, {
        ref: textRef,
        numberOfLines: isExpanded ? undefined : isMeasuring ? undefined : numberOfLines,
        style: styles,
        ellipsizeMode: "tail",
        text: text,
        type: type,
        onLayout: onLayout,
        textAlignment: textAlignment,
        color: color
      }), isTruncated && !isExpanded && _jsx(Button, Object.assign({
        onPress: toggleTextShown
      }, buttonProps, {
        title: readMoreText
      }))]
    }))
  });
};
export default TruncatedText;